export const formattedWeight = (amount:number) => {
    return new Intl.NumberFormat(undefined, {
        style: "unit",
        unit: 'kilogram',
        unitDisplay: "short",
    }).format(amount / 1000);
}